import FiltrosRapidosApi from "../api/FiltrosRapidosApi";
import { IFiltroRapido } from "../modelo/FiltroRapido";
import UsuarioStore from '../store/UsuarioStore';

class FiltrosRapidosService {

    async recuperarFiltrosDoUsuario(): Promise<IFiltroRapido[]> {
        const login = UsuarioStore.login || UsuarioStore.usuario?.login;
        const gabinete = UsuarioStore.gabinete || UsuarioStore.localizacao?.siglaOrgaoJulgador;

        if (!login || !gabinete) {
            return [];
        }

        let filtros = await FiltrosRapidosApi.recuperarFiltrosDoUsuario(String(login), gabinete);

        filtros = filtros.map(filtro => {
            if (filtro.cpf !== String(login)) {
                filtro.semPrivilegios = true;
            }
            return filtro;
        });

        return filtros;

    }

    async excluirFiltro(idFiltro) {
        return FiltrosRapidosApi.excluirFiltro(idFiltro);
    }

    async salvarNovoFiltro(filtro: IFiltroRapido) {
        if (typeof filtro.dados !== 'string') {
            filtro.dados = JSON.stringify(filtro.dados);
        }

        return await FiltrosRapidosApi.salvarNovoFiltro(filtro);
    }

    async alterarFiltro(filtro: IFiltroRapido): Promise<IFiltroRapido> {
        if (typeof filtro.dados !== 'string') {
            filtro.dados = JSON.stringify(filtro.dados);
        }
        return await FiltrosRapidosApi.alterarFiltro(filtro);
    }
}

export default new FiltrosRapidosService();